/**
 * Main JavaScript entry point for Luxury Auction theme
 * Handles component initialization and global functionality
 */

// Import header components
/*
import { initializeHelpers } from './utils/helpers';
*/
import { MobileMenu } from './components/header/mobile-menu';


class LuxuryAuctionTheme {
    constructor() {
        this.mobileMenu = null;
        this.initialize();
    }

    initialize() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initializeComponents();
            this.setupEventListeners();
        });

        window.addEventListener('error', this.handleGlobalError.bind(this));
    }

    initializeComponents() {
        // Initialize utility helpers
        //initializeHelpers();

        // Initialize header components
        this.mobileMenu = new MobileMenu();
    }

    setupEventListeners() {
        // Add global event listeners if needed
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
        // Handle responsive behavior
        if (window.innerWidth >= 1024 && this.mobileMenu) {
            this.mobileMenu.closeMenu();
        }
    }

    handleGlobalError(event) {
        console.error('Global error handler:', event.error);
        // Add error reporting service integration here if needed
    }
}

// Initialize the theme
new LuxuryAuctionTheme();